import { createEvent, createStore } from 'effector';
import { createGate } from 'effector-react';
import type { Notification } from '../../types';

export const NotificationGate = createGate();

export const notificationMounted = NotificationGate.open;
export const notificationUnmounted = NotificationGate.close;

export const $notification = createStore<Notification | null>(null);
export const $notifications = createStore<Notification[]>([]);

/**
 * Отображение уведомления об успехе
 * @param notification - объект уведомления с полями:
 *   - title - заголовок уведомления (необязательно)
 *   - label - текст уведомления
 *   - action - действие в уведомлении (необязательно)
 *   - code - код ошибки (необязательно)
 */
export const showSuccessNotification = createEvent<Notification>();

/**
 * Отображение информационного уведомления
 * @param notification - объект уведомления с полями:
 *   - title - заголовок уведомления (необязательно)
 *   - label - текст уведомления
 *   - action - действие в уведомлении (необязательно)
 *   - code - код ошибки (необязательно)
 */
export const showInfoNotification = createEvent<Notification>();

/**
 * Отображение предупреждающего уведомления
 * @param notification - объект уведомления с полями:
 *   - title - заголовок уведомления (необязательно)
 *   - label - текст уведомления
 *   - action - действие в уведомлении (необязательно)
 *   - code - код ошибки (необязательно)
 */
export const showWarningNotification = createEvent<Notification>();

/**
 * Отображение уведомления об ошибке
 * @param notification - объект уведомления с полями:
 *   - title - заголовок уведомления (необязательно)
 *   - label - текст уведомления
 *   - action - действие в уведомлении (необязательно)
 *   - code - код ошибки (необязательно)
 */
export const showErrorNotification = createEvent<Notification>();
export const hideNotification = createEvent<Notification>();